import { useQuery } from '../../../hooks';

import * as customersService from '../service';
import { CustomersCacheKeys } from '../consts';
import { AccountType } from '../../common';

export const useCustomerDashboard = (accountType: AccountType) => {
  const getCustomerDashboard = useQuery({
    queryFn: async () => {
      switch (accountType) {
        case AccountType.DEMAND:
          return customersService.getDemandDashboard();

        case AccountType.SUPPLY:
        default:
          return customersService.getSupplierDashboard();
      }
    },
    queryKey: [CustomersCacheKeys.GetCustomerDashboard, accountType],
    enabled: !!accountType,
  });

  return {
    getCustomerDashboard,
  };
};
